import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  getPresetNamesFromUrl,
  hasLegacyPresetSuffix,
  PresetNames,
  setPresetSearchParams,
  stripLegacyPresetPath
} from './preset-url-utils';

/**
 * The page/table preset names in the current URL. A legacy `/_page-preset=…` path suffix is read
 * directly (no waiting on presets) and immediately rewritten, in place, to the query-string form.
 */
export const usePresetUrl = (): PresetNames => {
  const location = useLocation();
  const navigate = useNavigate();
  const { '*': splat = '' } = useParams<{ '*'?: string }>();
  const { pathname, search } = location;
  const names = useMemo(() => getPresetNamesFromUrl(search, splat), [search, splat]);

  useEffect(() => {
    if (hasLegacyPresetSuffix(splat)) {
      navigate(
        {
          pathname: stripLegacyPresetPath(pathname),
          search: setPresetSearchParams(search, names)
        },
        { replace: true }
      );
    }
  }, [navigate, names, pathname, search, splat]);

  return names;
};
